import { CSSObjectWithLabel, GroupBase, OptionProps, StylesConfig } from 'react-select';

import globalTheme from '../../theme';
import { Option } from '../types';

export const commonTheme: StylesConfig<Option, boolean, GroupBase<Option>> = {
  control: (base: CSSObjectWithLabel) => ({
    ...base,
    cursor: 'pointer',
    height: '40px',
    borderRadius: '4px',
    padding: `${globalTheme.spacers!.spacer01} ${globalTheme.spacers!.spacer03}`,
    border: `1px solid ${globalTheme.admanColors!.gray.light.bg0[3]}`,
    transition: 'none',
    boxShadow: 'none',
    '&:hover': {
      border: `2px solid ${globalTheme.admanColors!.gray.light.bg0[5]}`,
      padding: '3px 11px',
    },
    '&:focus-within': {
      border: '2px solid #040405',
      padding: '3px 11px',
    },
  }),
  valueContainer: (base: CSSObjectWithLabel) => ({
    ...base,
    fontSize: '14px',
    padding: 0,
  }),
  singleValue: (base: CSSObjectWithLabel) => ({
    ...base,
    color: 'inherit',
  }),
  indicatorsContainer: (base: CSSObjectWithLabel) => ({
    ...base,
    gap: globalTheme.spacers!.spacer01,
  }),
  clearIndicator: (base: CSSObjectWithLabel) => ({
    ...base,
    '> svg': {
      fill: '#040405',
      border: '2px solid #040405',
      borderRadius: '50%',
    },
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  placeholder: (base: CSSObjectWithLabel) => ({
    ...base,
    color: '#4f535c',
  }),
  menu: (base: CSSObjectWithLabel) => ({
    ...base,
    margin: '0',
    padding: '0',
    width: '100%',
    background: globalTheme.admanColors!.gray.light.bg0[0],
    boxShadow: '0px 2px 1px rgba(0,0,0,0.2), 0px 1px 1px rgba(0,0,0,0.14), 0px 1px 3px rgba(0,0,0,0.12)',
    borderRadius: '8px',
    zIndex: '10',
  }),
  menuList: (base: CSSObjectWithLabel) => ({
    ...base,
    padding: 0,
    maxHeight: '250px',
    borderRadius: '8px',
  }),
};

const theme: StylesConfig<Option, false, GroupBase<Option>> = {
  ...commonTheme,
  option: (base: CSSObjectWithLabel, props: OptionProps<Option, false, GroupBase<Option>>) => ({
    ...base,
    display: 'block',
    width: '100%',
    cursor: 'pointer',
    position: 'relative',
    flexDirection: 'row',
    fontSize: '14px',
    padding: `13.5px ${globalTheme.spacers!.spacer05}`,
    lineHeight: '21px',
    background: globalTheme.admanColors!.gray.light.bg0[0],
    color: props.isSelected ? '#8498A9' : '#1950B5',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    height: '45px',
    '&:after': {
      content: '""',
      display: 'block',
      borderBottom: '1px solid #D4DEE3',
      bottom: 0,
      position: 'absolute',
      width: '100%',
      left: 0,
    },
    '&:hover': {
      background: '#F7F7F9',
      color: '#040405',
    },
  }),
};

export default theme;
